<kendo-combobox
    textField="name"
    valueField="id"
    (filterChange)="onFilterChange($event)"
    [data]="contacts"
    [readonly]="readonly"
    [value]="_value"
    [filterable]="true"
    [valuePrimitive]="valuePrimitive"
    [disabled]="disabled"
    (valueChange)="onValueChange($event)"
    [popupSettings]="{ popupClass: 'popup-combo', width: 'auto' }"
    placeholder="Kontakt suchen"
>
    <ng-template kendoComboBoxItemTemplate let-dataItem>
        {{ dataItem.isCompany ?  dataItem.companyName : dataItem.firstName + " " + dataItem.lastName}}
    </ng-template>
    <ng-template kendoComboBoxItemTemplate let-dataItem>
        {{ dataItem.isCompany ?  dataItem.companyName : dataItem.firstName + " " + dataItem.lastName}}
    </ng-template>
    <ng-template kendoComboBoxNoDataTemplate>
        <span>Keine Kontakte gefunden. Bitte Suchbegriff ändern.</span>
    </ng-template>
</kendo-combobox>